// @flow
import { type VideoDetails } from 'app/common/react/components/closeup/lib';

// hlsv3 should always exist, but due to a bug the conditional below is needed.
// Will be coming back to fix hlsv3 bug.
const toMaybeWideVideo: (video: VideoDetails) => boolean = (video) => {
  const { hlsv3, hls } = video;
  const vid = hlsv3 || hls;
  return !!vid && vid.width > vid.height;
};

export default toMaybeWideVideo;
